export default {
    state: {
        shopsSearchSelected: null,
        shopsPosition: null,
    },
    actions: {},
    mutations: {
        SHOPS_POSITION: function (state, val) {
            state.shopsPosition = val;
        },
        SHOPS_SEARCH_SELECTED: function (state, val) {
            state.shopsSearchSelected = val;
        }
    },
    getters: {}
};
